import React from "react";
import axios from "axios";
import { BASE_URL } from "./Config";

const Test = () => {
  const contacts = ["919876543210", "911234567890"];
  const message = "Hello! This is a WhatsApp auto-message from PHP backend.";

  const sendMassMessage = async () => {
    try {
      const res = await axios.post(`${BASE_URL}/autofunctional/send.php`, {
        contacts,
        message,
      });
      console.log(res)
      console.log(res.data);
      alert("Messages sent!");
    } catch (err) {
      console.error("Failed:", err);
      alert("Sending failed.");
    }
  };

  return <button onClick={sendMassMessage}>Send via WhatsApp</button>;
};

export default Test;
